/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CareyApproval,
  CareyApprovalDecision,
  ChatArchive,
  ChatLastRead,
  ChatShortcut,
  ErrorResponse,
  IntegerResource,
  StringResource,
  UnreadCount,
} from '../models';
import {
    CareyApprovalFromJSON,
    CareyApprovalToJSON,
    CareyApprovalDecisionFromJSON,
    CareyApprovalDecisionToJSON,
    ChatArchiveFromJSON,
    ChatArchiveToJSON,
    ChatLastReadFromJSON,
    ChatLastReadToJSON,
    ChatShortcutFromJSON,
    ChatShortcutToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    IntegerResourceFromJSON,
    IntegerResourceToJSON,
    StringResourceFromJSON,
    StringResourceToJSON,
    UnreadCountFromJSON,
    UnreadCountToJSON,
} from '../models';

export interface AddChatShortcutRequest {
    chatShortcut: ChatShortcut;
}

export interface ArchiveChatRoomRequest {
    chatId: string;
}

export interface ClaimChatRoomRequest {
    chatId: string;
}

export interface CreateCareyChatRoomRequest {
    patientId: string;
}

export interface CreateHelpdeskChatRoomRequest {
    patientId: string;
}

export interface CreateOnDemandChatRoomRequest {
    patientId: string;
}

export interface GetCareyApprovalRequest {
    requestId: string;
}

export interface GetChatFileRequest {
    name: string;
    chatId: string;
}

export interface GetChatLastReadRequest {
    userId: string;
}

export interface GetUnreadCountRequest {
    userId: string;
}

export interface GetUserArchivesRequest {
    userId: string;
    role: GetUserArchivesRoleEnum;
}

export interface RespondToCareyApprovalRequest {
    requestId: string;
    careyApprovalDecision: CareyApprovalDecision;
}

export interface TransferChatRequest {
    chatId: string;
    userId: string;
}

export interface UnarchiveChatRoomRequest {
    chatId: string;
}

export interface UpdateChatLastReadRequest {
    userId: string;
    roomId: string;
    integerResource: IntegerResource;
}

export interface UpdateUnreadCountRequest {
    userId: string;
    integerResource: IntegerResource;
}

export interface UploadChatFileRequest {
    chatId: string;
    file: Blob;
    note?: string;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     * Adds a chat shortcut (Roles: physician, admin)
     */
    async addChatShortcutRaw(requestParameters: AddChatShortcutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatShortcut>> {
        if (requestParameters.chatShortcut === null || requestParameters.chatShortcut === undefined) {
            throw new runtime.RequiredError('ChatShortcut','Required parameter requestParameters.chatShortcut was null or undefined when calling addChatShortcut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/shortcuts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatShortcutToJSON(requestParameters.chatShortcut),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatShortcutFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addChatShortcutRequestOptionsRaw(requestParameters: AddChatShortcutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.chatShortcut === null || requestParameters.chatShortcut === undefined) {
            throw new runtime.RequiredError('ChatShortcut','Required parameter requestParameters.chatShortcut was null or undefined when calling addChatShortcut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/shortcuts`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ChatShortcutToJSON(requestParameters.chatShortcut),
        };
        return responseConfig
    }

    /**
     * Adds a chat shortcut (Roles: physician, admin)
     */
    async addChatShortcut(requestParameters: AddChatShortcutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatShortcut> {
        const response = await this.addChatShortcutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Archives a chat room (Roles: admin, physician)
     */
    async archiveChatRoomRaw(requestParameters: ArchiveChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling archiveChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/room/{chatId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    archiveChatRoomRequestOptionsRaw(requestParameters: ArchiveChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling archiveChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/room/{chatId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Archives a chat room (Roles: admin, physician)
     */
    async archiveChatRoom(requestParameters: ArchiveChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.archiveChatRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claims a helpdesk chat room (Roles: admin, physician)
     */
    async claimChatRoomRaw(requestParameters: ClaimChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling claimChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/room/{chatId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    claimChatRoomRequestOptionsRaw(requestParameters: ClaimChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling claimChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/room/{chatId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Claims a helpdesk chat room (Roles: admin, physician)
     */
    async claimChatRoom(requestParameters: ClaimChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.claimChatRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a Carey AI assistant chat (Roles: patient)
     */
    async createCareyChatRoomRaw(requestParameters: CreateCareyChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling createCareyChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/carey/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createCareyChatRoomRequestOptionsRaw(requestParameters: CreateCareyChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling createCareyChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/carey/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Creates a Carey AI assistant chat (Roles: patient)
     */
    async createCareyChatRoom(requestParameters: CreateCareyChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.createCareyChatRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a helpdesk chat (Roles: patient)
     */
    async createHelpdeskChatRoomRaw(requestParameters: CreateHelpdeskChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling createHelpdeskChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/helpdesk/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createHelpdeskChatRoomRequestOptionsRaw(requestParameters: CreateHelpdeskChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling createHelpdeskChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/helpdesk/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Creates a helpdesk chat (Roles: patient)
     */
    async createHelpdeskChatRoom(requestParameters: CreateHelpdeskChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.createHelpdeskChatRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates an on-demand chat (Roles: admin, physician)
     */
    async createOnDemandChatRoomRaw(requestParameters: CreateOnDemandChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling createOnDemandChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/ondemand/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createOnDemandChatRoomRequestOptionsRaw(requestParameters: CreateOnDemandChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling createOnDemandChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/ondemand/patient/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Creates an on-demand chat (Roles: admin, physician)
     */
    async createOnDemandChatRoom(requestParameters: CreateOnDemandChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.createOnDemandChatRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets recently archived chats (Roles: admin, physician)
     */
    async getArchivedChatRoomsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatArchive>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/archived-rooms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatArchiveFromJSON));
    }

    /**
        Request Config Getter
     */
    getArchivedChatRoomsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/archived-rooms`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets recently archived chats (Roles: admin, physician)
     */
    async getArchivedChatRooms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatArchive>> {
        const response = await this.getArchivedChatRoomsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the status of a Carey action-approval request (Roles: patient)
     */
    async getCareyApprovalRaw(requestParameters: GetCareyApprovalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CareyApproval>> {
        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling getCareyApproval.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/carey/approvals/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CareyApprovalFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getCareyApprovalRequestOptionsRaw(requestParameters: GetCareyApprovalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling getCareyApproval.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/carey/approvals/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the status of a Carey action-approval request (Roles: patient)
     */
    async getCareyApproval(requestParameters: GetCareyApprovalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CareyApproval> {
        const response = await this.getCareyApprovalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a chat file (Roles: admin, physician, patient)
     */
    async getChatFileRaw(requestParameters: GetChatFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getChatFile.');
        }

        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling getChatFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/room/{chatId}/file/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
        Request Config Getter
     */
    getChatFileRequestOptionsRaw(requestParameters: GetChatFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getChatFile.');
        }

        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling getChatFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/room/{chatId}/file/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a chat file (Roles: admin, physician, patient)
     */
    async getChatFile(requestParameters: GetChatFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getChatFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a patient\'s per-chat last-read markers (Roles: patient)
     */
    async getChatLastReadRaw(requestParameters: GetChatLastReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatLastRead>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getChatLastRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/last-read/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatLastReadFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getChatLastReadRequestOptionsRaw(requestParameters: GetChatLastReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getChatLastRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/last-read/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a patient\'s per-chat last-read markers (Roles: patient)
     */
    async getChatLastRead(requestParameters: GetChatLastReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatLastRead> {
        const response = await this.getChatLastReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets active chat rooms (Roles: admin, physician)
     */
    async getChatRoomsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatArchive>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/rooms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatArchiveFromJSON));
    }

    /**
        Request Config Getter
     */
    getChatRoomsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/rooms`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets active chat rooms (Roles: admin, physician)
     */
    async getChatRooms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatArchive>> {
        const response = await this.getChatRoomsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all chat shortcuts (Roles: physician, admin)
     */
    async getChatShortcutsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatShortcut>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/shortcuts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatShortcutFromJSON));
    }

    /**
        Request Config Getter
     */
    getChatShortcutsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/shortcuts`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all chat shortcuts (Roles: physician, admin)
     */
    async getChatShortcuts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatShortcut>> {
        const response = await this.getChatShortcutsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets own active chat rooms (Roles: admin, physician, patient)
     */
    async getOwnChatRoomsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatArchive>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/own/rooms`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatArchiveFromJSON));
    }

    /**
        Request Config Getter
     */
    getOwnChatRoomsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/own/rooms`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets own active chat rooms (Roles: admin, physician, patient)
     */
    async getOwnChatRooms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatArchive>> {
        const response = await this.getOwnChatRoomsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets a patient\'s unread count (Roles: patient)
     */
    async getUnreadCountRaw(requestParameters: GetUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnreadCount>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUnreadCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/unread-count/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnreadCountFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getUnreadCountRequestOptionsRaw(requestParameters: GetUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUnreadCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/unread-count/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets a patient\'s unread count (Roles: patient)
     */
    async getUnreadCount(requestParameters: GetUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnreadCount> {
        const response = await this.getUnreadCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s chat archives (Roles: patient, admin, physician)
     */
    async getUserArchivesRaw(requestParameters: GetUserArchivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatArchive>>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserArchives.');
        }

        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling getUserArchives.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/{role}/{userId}/archives`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatArchiveFromJSON));
    }

    /**
        Request Config Getter
     */
    getUserArchivesRequestOptionsRaw(requestParameters: GetUserArchivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUserArchives.');
        }

        if (requestParameters.role === null || requestParameters.role === undefined) {
            throw new runtime.RequiredError('role','Required parameter requestParameters.role was null or undefined when calling getUserArchives.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/{role}/{userId}/archives`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"role"}}`, encodeURIComponent(String(requestParameters.role))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get a user\'s chat archives (Roles: patient, admin, physician)
     */
    async getUserArchives(requestParameters: GetUserArchivesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatArchive>> {
        const response = await this.getUserArchivesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Approves or denies a Carey action-approval request (Roles: patient)
     */
    async respondToCareyApprovalRaw(requestParameters: RespondToCareyApprovalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CareyApproval>> {
        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling respondToCareyApproval.');
        }

        if (requestParameters.careyApprovalDecision === null || requestParameters.careyApprovalDecision === undefined) {
            throw new runtime.RequiredError('CareyApprovalDecision','Required parameter requestParameters.careyApprovalDecision was null or undefined when calling respondToCareyApproval.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/carey/approvals/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CareyApprovalDecisionToJSON(requestParameters.careyApprovalDecision),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CareyApprovalFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    respondToCareyApprovalRequestOptionsRaw(requestParameters: RespondToCareyApprovalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling respondToCareyApproval.');
        }

        if (requestParameters.careyApprovalDecision === null || requestParameters.careyApprovalDecision === undefined) {
            throw new runtime.RequiredError('CareyApprovalDecision','Required parameter requestParameters.careyApprovalDecision was null or undefined when calling respondToCareyApproval.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/carey/approvals/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: CareyApprovalDecisionToJSON(requestParameters.careyApprovalDecision),
        };
        return responseConfig
    }

    /**
     * Approves or denies a Carey action-approval request (Roles: patient)
     */
    async respondToCareyApproval(requestParameters: RespondToCareyApprovalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CareyApproval> {
        const response = await this.respondToCareyApprovalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Transfers a chat to a different user (Roles: admin)
     */
    async transferChatRaw(requestParameters: TransferChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling transferChat.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling transferChat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/room/{chatId}/transfer/{userId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    transferChatRequestOptionsRaw(requestParameters: TransferChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling transferChat.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling transferChat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/room/{chatId}/transfer/{userId}`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Transfers a chat to a different user (Roles: admin)
     */
    async transferChat(requestParameters: TransferChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.transferChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unarchive a helpdesk chat (Roles: admin, physician)
     */
    async unarchiveChatRoomRaw(requestParameters: UnarchiveChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatArchive>> {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling unarchiveChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/archived-rooms/{chatId}/unarchive`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatArchiveFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    unarchiveChatRoomRequestOptionsRaw(requestParameters: UnarchiveChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling unarchiveChatRoom.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/archived-rooms/{chatId}/unarchive`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Unarchive a helpdesk chat (Roles: admin, physician)
     */
    async unarchiveChatRoom(requestParameters: UnarchiveChatRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatArchive> {
        const response = await this.unarchiveChatRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a patient\'s last-read marker for a chat room (Roles: patient)
     */
    async updateChatLastReadRaw(requestParameters: UpdateChatLastReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateChatLastRead.');
        }

        if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
            throw new runtime.RequiredError('roomId','Required parameter requestParameters.roomId was null or undefined when calling updateChatLastRead.');
        }

        if (requestParameters.integerResource === null || requestParameters.integerResource === undefined) {
            throw new runtime.RequiredError('IntegerResource','Required parameter requestParameters.integerResource was null or undefined when calling updateChatLastRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/last-read/{userId}/{roomId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegerResourceToJSON(requestParameters.integerResource),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    updateChatLastReadRequestOptionsRaw(requestParameters: UpdateChatLastReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateChatLastRead.');
        }

        if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
            throw new runtime.RequiredError('roomId','Required parameter requestParameters.roomId was null or undefined when calling updateChatLastRead.');
        }

        if (requestParameters.integerResource === null || requestParameters.integerResource === undefined) {
            throw new runtime.RequiredError('IntegerResource','Required parameter requestParameters.integerResource was null or undefined when calling updateChatLastRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/last-read/{userId}/{roomId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))).replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: IntegerResourceToJSON(requestParameters.integerResource),
        };
        return responseConfig
    }

    /**
     * Updates a patient\'s last-read marker for a chat room (Roles: patient)
     */
    async updateChatLastRead(requestParameters: UpdateChatLastReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateChatLastReadRaw(requestParameters, initOverrides);
    }

    /**
     * Deprecated: unread counts are now derived server-side from per-chat last-read markers. Use PUT /chat/last-read/{userId}/{roomId} instead.
     * Updates a patient\'s unread count (Roles: patient)
     */
    async updateUnreadCountRaw(requestParameters: UpdateUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateUnreadCount.');
        }

        if (requestParameters.integerResource === null || requestParameters.integerResource === undefined) {
            throw new runtime.RequiredError('IntegerResource','Required parameter requestParameters.integerResource was null or undefined when calling updateUnreadCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/chat/unread-count/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegerResourceToJSON(requestParameters.integerResource),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    updateUnreadCountRequestOptionsRaw(requestParameters: UpdateUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateUnreadCount.');
        }

        if (requestParameters.integerResource === null || requestParameters.integerResource === undefined) {
            throw new runtime.RequiredError('IntegerResource','Required parameter requestParameters.integerResource was null or undefined when calling updateUnreadCount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/chat/unread-count/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: IntegerResourceToJSON(requestParameters.integerResource),
        };
        return responseConfig
    }

    /**
     * Deprecated: unread counts are now derived server-side from per-chat last-read markers. Use PUT /chat/last-read/{userId}/{roomId} instead.
     * Updates a patient\'s unread count (Roles: patient)
     */
    async updateUnreadCount(requestParameters: UpdateUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUnreadCountRaw(requestParameters, initOverrides);
    }

    /**
     * Uploads a chat file (Roles: admin, physician, patient)
     */
    async uploadChatFileRaw(requestParameters: UploadChatFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling uploadChatFile.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadChatFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.note !== undefined) {
            formParams.append('note', requestParameters.note as any);
        }

        const response = await this.request({
            path: `/chat/room/{chatId}/file`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    uploadChatFileRequestOptionsRaw(requestParameters: UploadChatFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.chatId === null || requestParameters.chatId === undefined) {
            throw new runtime.RequiredError('chatId','Required parameter requestParameters.chatId was null or undefined when calling uploadChatFile.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadChatFile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.note !== undefined) {
            formParams.append('note', requestParameters.note as any);
        }


        const responseConfig = {
            path: `/chat/room/{chatId}/file`.replace(`{${"chatId"}}`, encodeURIComponent(String(requestParameters.chatId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Uploads a chat file (Roles: admin, physician, patient)
     */
    async uploadChatFile(requestParameters: UploadChatFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.uploadChatFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetUserArchivesRoleEnum = {
    Physician: 'physician',
    Patient: 'patient',
    Admin: 'admin',
    Phlebotomist: 'phlebotomist'
} as const;
export type GetUserArchivesRoleEnum = typeof GetUserArchivesRoleEnum[keyof typeof GetUserArchivesRoleEnum];
